/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import ActionBar from './components/ActionBar'
import AssetCard from '@/components/cards/AssetCard'
import { YOUR_ASSETS } from '@/configs/strings/your-assets'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getAssets, getAssetsAsCsv } from '@/services/assets'
import { useAssets } from './useAssets'
import ItemsListWithToggleLayout from '@/components/wrappers/general/ItemsListWithToggleLayout'
import { Box } from '@chakra-ui/react'
import DownloadFileButton from '@/components/buttons/DownloadFileButton'
import { EXPORT_CSV } from '@/configs/strings/listings'
import DefaultTableHidingColumns from '@/components/tables/DefaultTableHidingColumns'

const AssetList = () => {
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    searchParams,
    setSearchParams,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getAssets
  })

  const {
    getCardProps,
    getItemsPropsForTable,
    tableColumns,
    tableInitialState
  } = useAssets()
  const assets = itemsResponse?.assets.map(asset => {
    const cardProps = getCardProps(asset)
    return (
      <AssetCard
        key={cardProps.key}
        {...cardProps}
      />
    )
  })
  const table = <DefaultTableHidingColumns
    columns={tableColumns}
    data={itemsResponse?.assets}
    getItemProps={getItemsPropsForTable}
    tableInitialState={tableInitialState}
    visibleColumnsParamKey="visibleColumns"
  />

  return (
    <RegularTemplate
      title={YOUR_ASSETS}
      loadingContent={loading}
    >
      <Box mb="4">
        <DownloadFileButton
          service={getAssetsAsCsv}
          isDisabled={!itemsResponse?.assets.length}
            dataKey="csv"
        >
          { EXPORT_CSV }
        </DownloadFileButton>
      </Box>
      <ItemsListWithToggleLayout
        cards={assets}
        currentPage={+page}
        header={
          <ActionBar
            onFilterResults={(filter) => setSearchParams(filter)}
            onReset={() => setSearchParams({})}
            searchParams={searchParams}
          />
        }
        itemsLayout={searchParams.itemsLayout}
        onChangePage={onChangePage}
        searchParams={searchParams}
        table={table}
        totalItems={itemsResponse?.total}
        totalPages={totalPages}
      />
  </RegularTemplate>
  )
}

export default AssetList
